import React from 'react';
import '../styles/HowItWorks.css';

// Try to import the demo video, but provide fallback if it doesn't exist yet
let agentsVideo;
try {
  agentsVideo = require('../assets/agents-working.mp4');
} catch (e) {
  // Video will be handled with a placeholder if it doesn't exist
}

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Select an AI Agent",
      description: "Browse our library of 100+ specialized AI agents and choose the one that fits your task."
    },
    {
      number: "02",
      title: "Describe Your Goal",
      description: "Simply tell the AI agent what you want to accomplish in plain language."
    },
    {
      number: "03", 
      title: "Review & Launch",
      description: "Check the AI's plan, make any adjustments, and set your automation in motion."
    },
    {
      number: "04",
      title: "Monitor Results",
      description: "Track performance in real-time and let the AI optimize based on results."
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <h2>How It Works: <span className="highlight">Simplicity By Design</span></h2>
        <p className="section-subtitle">
          We've made business automation as easy as having a conversation
        </p>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="demo-container">
          <div className="demo-text">
            <h3>See It In Action</h3>
            <p>Watch our 100+ AI agents transform tedious tasks into automated workflows in seconds:</p>
            <ul className="demo-points">
              <li>Access specialized agents for marketing, sales, content, and more</li>
              <li>Set up complex workflows with simple conversational inputs</li>
              <li>Generate affiliate connections, content, and social campaigns</li>
              <li>Automate personalized outreach at scale</li>
              <li>Monitor performance and optimize results across all channels</li>
            </ul>
          </div>
          <div className="demo-visual">
            {agentsVideo ? (
              <video 
                className="demo-video" 
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src={agentsVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <div className="demo-placeholder">
                [AI Agents Demo Video]
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
